import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Collapse from '@mui/material/Collapse';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function Navbar() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [servicesAnchor, setServicesAnchor] = useState(null);
  const [investmentsAnchor, setInvestmentsAnchor] = useState(null);

  const toggle = (val) => () => setOpen(val);

  const NavButton = ({ to, children }) => (
    <Button component={NavLink} to={to} color="inherit" sx={{ textTransform: 'none', fontWeight: 400, fontSize: { xs: '0.95rem', md: '1rem' } }}>
      {children}
    </Button>
  );

  return (
    <AppBar position="fixed" color="transparent" sx={{ backdropFilter: 'saturate(180%) blur(10px)', backgroundColor: 'rgba(0,0,0,0.35)' }}>
      <Toolbar sx={{ maxWidth: '112rem', width: '100%', mx: 'auto', minHeight: 72 }}>
        <Box component="a" href="/" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
          <Box component="img" src="https://res.cloudinary.com/dqwxmksbe/image/upload/v1762423871/blockfirstcapital-white-logo_xeaz9r.png" alt="Blockfirst Capital" sx={{ height: 32 }} />
        </Box>
        <Box sx={{ flex: 1 }} />
        <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 2.5, alignItems: 'center', color: 'white' }}>
          <NavButton to="/">Home</NavButton>
          <NavButton to="/about">About</NavButton>
          <Button
            color="inherit"
            endIcon={<ExpandMoreIcon />}
            aria-haspopup="true"
            aria-controls={investmentsAnchor ? 'investments-menu' : undefined}
            aria-expanded={Boolean(investmentsAnchor) ? 'true' : undefined}
            onMouseEnter={(e) => setInvestmentsAnchor(e.currentTarget)}
            onClick={(e) => setInvestmentsAnchor(e.currentTarget)}
            sx={{ textTransform: 'none', fontWeight: 400, fontSize: { xs: '0.95rem', md: '1rem' } }}
          >
            Investments
          </Button>
          <Menu
            id="investments-menu"
            anchorEl={investmentsAnchor}
            open={Boolean(investmentsAnchor)}
            onClose={() => setInvestmentsAnchor(null)}
            MenuListProps={{ onMouseLeave: () => setInvestmentsAnchor(null) }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            <MenuItem component={NavLink} to="/investments/healthcare" onClick={() => setInvestmentsAnchor(null)}>Healthcare</MenuItem>
            <MenuItem component={NavLink} to="/investments/digital-assets" onClick={() => setInvestmentsAnchor(null)}>Digital Assets</MenuItem>
            <MenuItem component={NavLink} to="/investments/agriculture" onClick={() => setInvestmentsAnchor(null)}>Agriculture</MenuItem>
            <MenuItem component={NavLink} to="/investments/real-estate" onClick={() => setInvestmentsAnchor(null)}>Real Estate</MenuItem>
            <MenuItem component={NavLink} to="/investments/technology" onClick={() => setInvestmentsAnchor(null)}>Technology</MenuItem>
            <MenuItem component={NavLink} to="/investments/industrial-technology" onClick={() => setInvestmentsAnchor(null)}>Industrial Technology</MenuItem>
          </Menu>
          <Button
            color="inherit"
            endIcon={<ExpandMoreIcon />}
            aria-haspopup="true"
            aria-controls={servicesAnchor ? 'services-menu' : undefined}
            aria-expanded={Boolean(servicesAnchor) ? 'true' : undefined}
            onMouseEnter={(e) => setServicesAnchor(e.currentTarget)}
            onClick={(e) => setServicesAnchor(e.currentTarget)}
            sx={{ textTransform: 'none', fontWeight: 400, fontSize: { xs: '0.95rem', md: '1rem' } }}
          >
            Services
          </Button>
          <Menu
            id="services-menu"
            anchorEl={servicesAnchor}
            open={Boolean(servicesAnchor)}
            onClose={() => setServicesAnchor(null)}
            MenuListProps={{ onMouseLeave: () => setServicesAnchor(null) }}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            <MenuItem component={NavLink} to="/portfolio-management" onClick={() => setServicesAnchor(null)}>Portfolio Management</MenuItem>
            <MenuItem component={NavLink} to="/financial-planning" onClick={() => setServicesAnchor(null)}>Financial Planning</MenuItem>
            <MenuItem component={NavLink} to="/risk-management" onClick={() => setServicesAnchor(null)}>Risk Management</MenuItem>
            <MenuItem component={NavLink} to="/wealth-management" onClick={() => setServicesAnchor(null)}>Wealth Management</MenuItem>
          </Menu>
          <NavButton to="/careers">Career</NavButton>
          <NavButton to="/contact">Contact</NavButton>
          <Button component={NavLink} to="/apply" variant="contained" size="medium" sx={{ ml: 1, textTransform: 'none', fontWeight: 800, px: 3, py: 1.2, background: 'linear-gradient(90deg, #fbbf24, #f59e0b)', color: '#111827', '&:hover': { background: 'linear-gradient(90deg, #f59e0b, #d97706)' } }}>Apply now</Button>
        </Box>
        <IconButton onClick={toggle(true)} sx={{ display: { xs: 'inline-flex', sm: 'none' }, color: 'white' }} aria-label="Open menu">
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="right" open={open} onClose={toggle(false)} ModalProps={{ keepMounted: true }} sx={{ '& .MuiDrawer-paper': { width: '78vw', maxWidth: 340 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
          <Box component="a" href="/" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <Box component="img" src="https://res.cloudinary.com/dqwxmksbe/image/upload/v1762423871/blockfirstcapital-white-logo_xeaz9r.png" alt="Blockfirst Capital" sx={{ height: 28 }} />
          </Box>
          <IconButton onClick={toggle(false)} aria-label="Close menu">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List sx={{ px: 1 }}>
          <ListItemButton component={NavLink} to="/" onClick={toggle(false)} sx={{ py: 1.25 }}>
            <ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="Home" />
          </ListItemButton>
          <ListItemButton component={NavLink} to="/about" onClick={toggle(false)} sx={{ py: 1.25 }}>
            <ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="About" />
          </ListItemButton>
          <ListItemButton onClick={() => setServicesOpen(!servicesOpen)} sx={{ py: 1.25 }}>
            <ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="Services" />
            <ExpandMoreIcon sx={{ transform: servicesOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s' }} />
          </ListItemButton>
          <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
            <Box sx={{ pl: 2 }}>
              <ListItemButton component={NavLink} to="/portfolio-management" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Portfolio Management" /></ListItemButton>
              <ListItemButton component={NavLink} to="/financial-planning" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Financial Planning" /></ListItemButton>
              <ListItemButton component={NavLink} to="/risk-management" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Risk Management" /></ListItemButton>
              <ListItemButton component={NavLink} to="/wealth-management" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Wealth Management" /></ListItemButton>
            </Box>
          </Collapse>
          {/* Investments mobile accordion */}
          <ListItemButton onClick={() => setInvestmentsAnchor((prev) => (prev ? null : true))} sx={{ py: 1.25 }}>
            <ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="Investments" />
            <ExpandMoreIcon sx={{ transform: investmentsAnchor ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s' }} />
          </ListItemButton>
          <Collapse in={Boolean(investmentsAnchor)} timeout="auto" unmountOnExit>
            <Box sx={{ pl: 2 }}>
              <ListItemButton component={NavLink} to="/investments/healthcare" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Healthcare" /></ListItemButton>
              <ListItemButton component={NavLink} to="/investments/digital-assets" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Digital Assets" /></ListItemButton>
              <ListItemButton component={NavLink} to="/investments/agriculture" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Agriculture" /></ListItemButton>
              <ListItemButton component={NavLink} to="/investments/real-estate" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Real Estate" /></ListItemButton>
              <ListItemButton component={NavLink} to="/investments/technology" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Technology" /></ListItemButton>
              <ListItemButton component={NavLink} to="/investments/industrial-technology" onClick={toggle(false)} sx={{ py: 1 }}><ListItemText primaryTypographyProps={{ fontWeight: 600 }} primary="Industrial Technology" /></ListItemButton>
            </Box>
          </Collapse>
          <ListItemButton component={NavLink} to="/careers" onClick={toggle(false)} sx={{ py: 1.25 }}><ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="Career" /></ListItemButton>
          <ListItemButton component={NavLink} to="/contact" onClick={toggle(false)} sx={{ py: 1.25 }}><ListItemText primaryTypographyProps={{ fontWeight: 700, fontSize: '1.05rem' }} primary="Contact" /></ListItemButton>
        </List>
        <Box sx={{ px: 2, pb: 3, pt: 1 }}>
          <Button component={NavLink} to="/apply" variant="contained" size="large" fullWidth sx={{ textTransform: 'none', fontWeight: 800, fontSize: '1.05rem', py: 1.2, background: 'linear-gradient(90deg, #fbbf24, #f59e0b)', color: '#111827', '&:hover': { background: 'linear-gradient(90deg, #f59e0b, #d97706)' } }}>Apply now</Button>
        </Box>
      </Drawer>
    </AppBar>
  );
}

export default Navbar;


